
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6aZOf", function(module, exports) {

$parcel$export(module.exports, "DataClassificationHoverButton", () => $5be98208ceff5d3b$export$75477e80681196d);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $a1qSg = parcelRequire("a1qSg");
const $5be98208ceff5d3b$var$buttonVisibleStyle = (0, $ecnYn.xcss)({
    opacity: 1,
    height: '26px'
});
const $5be98208ceff5d3b$var$buttonHiddenStyle = (0, $ecnYn.xcss)({
    opacity: 0
});
const $5be98208ceff5d3b$var$dataClassificationHoverButtonBoxStylesPadding0 = (0, $ecnYn.xcss)({
    padding: 'space.0'
});
const $5be98208ceff5d3b$export$75477e80681196d = /*#__PURE__*/ (0, $gwFzn.memo)(({ contentId: contentId, shouldShowHoverButton: shouldShowHoverButton, userOffline: userOffline, isContentTopperClassificationStyle: isContentTopperClassificationStyle = false, setIsClassificationMenuOpen: setIsClassificationMenuOpen, setIsClassificationButtonFocused: setIsClassificationButtonFocused, contentClassificationMetadata: contentClassificationMetadata, hasClassification: hasClassification, spaceKey: spaceKey })=>{
    const handleFocus = (0, $gwFzn.useCallback)(()=>{
        if (!isContentTopperClassificationStyle && setIsClassificationButtonFocused) setIsClassificationButtonFocused(true);
    }, [
        setIsClassificationButtonFocused,
        isContentTopperClassificationStyle
    ]);
    const handleBlur = (0, $gwFzn.useCallback)(()=>{
        if (!isContentTopperClassificationStyle && setIsClassificationButtonFocused) setIsClassificationButtonFocused(false);
    }, [
        setIsClassificationButtonFocused,
        isContentTopperClassificationStyle
    ]);
    if (hasClassification) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            shouldShowHoverButton ? $5be98208ceff5d3b$var$buttonVisibleStyle : $5be98208ceff5d3b$var$buttonHiddenStyle,
            !isContentTopperClassificationStyle && $5be98208ceff5d3b$var$dataClassificationHoverButtonBoxStylesPadding0
        ],
        testId: "data-classification-button-wrapper",
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a1qSg.EditorDataClassification), {
        contentId: contentId,
        userOffline: userOffline,
        onClassificationMenuToggle: setIsClassificationMenuOpen,
        isContentTopperClassificationStyle: isContentTopperClassificationStyle,
        contentClassificationMetadata: contentClassificationMetadata,
        spaceKey: spaceKey
    }));
});

});


//# sourceMappingURL=DataClassificationHoverButton.14f53873.js.map
